import React, { useContext, useMemo } from 'react'
import { DatabaseContext } from '../DatabaseContext';
import { fsCallAll } from '../contextHelpers/fcCalls';
import { AppContext } from '../AppProvider';
import { fsfn_sheets } from 'global/functions/fbSheetsFuntions';

export const useSheets = () => {

  const { database_fns } = useContext(DatabaseContext) ?? {};
  const { app_state } = useContext(AppContext);

  const { mainFunctions, app_alts, app_prods } = app_state ?? {};
  const { altFunctions } = app_alts ?? {};
  const { prodFunctions } = app_prods ?? {};

  // ---- combine functions ----
  const allFunctions = useMemo(
    () => ({ mainFunctions, altFunctions, prodFunctions }),
    [mainFunctions, altFunctions, prodFunctions]
  );

  const fsCall = async (genericType, callData) => {
    return fsCallAll(mainFunctions, genericType, callData, allFunctions, _showCallLogs);
  };

  const sheets_fns = useMemo(() => ({
    ...fsfn_sheets(fsCall, database_fns)
  }), [fsCall, database_fns]);

  return { sheets_fns }
}
